import * as HelperModel from '@/models/news.js'

class NewsHelpers {

    newItemModel() {
        return JSON.parse(JSON.stringify(HelperModel.newItem))
    }

}

const NewsHelper = new NewsHelpers
export default NewsHelper
